import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from '@/components/HelloWorld'
// import formaturl from './import_development'
let formaturl = require("./import_development").formaturl;
console.log("输出formaturl:", formaturl);
Vue.use(Router);
let cashPage = formaturl("cashPage/index");
let merchantTransfer = formaturl("merchantTransfer/index")
let withdrawalResult = formaturl("merchantTransfer/result")
let order = formaturl("order/index");
let pay = formaturl("pay/index");
let statistics = formaturl("statistics/index");
let author = formaturl("author/index");
let success = formaturl("pay/success");
let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      redirect: "/success"
    },
    {
      path: "/cashPage",
      name: "cashPage",
      component: cashPage
    },
    {
      path: "/merchantTransfer",
      name: "merchantTransfer",
      component: merchantTransfer
    },
    {
      path: '/withdrawalResult',
      name: 'withdrawalResult',
      component: withdrawalResult,
    },
    {
      path: '/transferAuthorization',
      name: 'transferAuthorization',
      component: formaturl("transferAuthorization/index"),
    },
    {
      path: '/transferSuccess',
      name: 'transferSuccess',
      component: formaturl("transferAuthorization/success"),
    },
    {
      path: "/order",
      name: "order",
      component: order
    },
    {
      path: "/pay",
      name: "pay",
      component: pay
    },
    {
      path: "/statistics",
      name: "statistics",
      component: statistics
    },
    {
      path: "/author",
      name: "author",
      component: author
    },
    {
      path: "/success",
      name: "success",
      component: success
    }
  ]
});

router.beforeEach((to, from, next) => {
  let href = window.location.href;
  if (process.env.NODE_ENV == "development") {
    sessionStorage.setItem("data", JSON.stringify(to.query));
    localStorage.setItem("openid", "oC-ey5yZbPNS_gHfsyAvpS7hGLYo");
    next();
  } else {
    if (
      href.indexOf("myapp_id=") != -1 &&
      href.indexOf("subject=") != -1 &&
      href.indexOf("device_id=") != -1 &&
      href.indexOf("device_sn=") != -1
    ) {
      let url = window.location.href.split("?")[1];
      localStorage.setItem("localhref", url);
      let goodsDetail = {
        myapp_id: Number(href.split("myapp_id=")[1].split("&")[0]),
        subject: href.split("subject=")[1].split("&")[0],
        device_id: href.split("device_id=")[1].split("&")[0],
        device_sn: href.split("device_sn=")[1].split("&")[0]
      };
      localStorage.setItem("data", JSON.stringify(goodsDetail));
      console.log(localStorage.getItem("data"));
    }else{
      if(to.path == "/transferAuthorization"){
        sessionStorage.setItem("data", JSON.stringify(to.query));
      }
    }
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
      if (to.path == "/pay") {
        if (
          !localStorage.getItem("openid") ||
          (localStorage.getItem("openid") == "undefined" &&
            to.path != "/author")
        ) {
          next("/author");
        } else {
          next();
        }
      }
    }

    if (to.path == "/author") {
      to.meta.keepAlive = true;
    }
    if (to.query.myapp_id && to.path == "/cashPage") {
      console.log(to.query);
      sessionStorage.setItem("data", JSON.stringify(to.query));
      next("/cashPage");
    }
    next();
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js